(function() {
    window.questLineService = {
      get(data) {
        return axios.get('/api/quest/get.php');
      },
      save(data) {
        return axios.post('/api/quest/save.php', data);
      },
      getCurrentQuest(){
        return axios.post(
           `/api/user/quest/get.php?twitchId=${utils.cookies.get('user_id')}`
          );
      },
      saveUserQuest(data){
        data.twitchId = utils.cookies.get('user_id');
        return axios.post('/api/user/quest/save.php', data);
      }
    }
  })();